import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { module } from 'modujs'

gsap.registerPlugin(ScrollTrigger)

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: {
      toggleFilters: 'toggleFilters',
      filterByTag: 'filterByTag'
    } }

    this.onKeyDown = this.onKeyDown.bind(this)
    this.onFocusIn = this.onFocusIn.bind(this)
    this.onClickDoc = this.onClickDoc.bind(this)

    this.moduleToFilter = this.el.dataset.filterModuleTarget

    this.el.$module = this
  }

  init() {
    this.isFiltersOpen = false
    this.isFiltering = false

    this.filtersBtnEl = this.el.querySelector('.filter-btn__btn')
    this.filtersBtnTextEl = this.el.querySelector('.filter-btn__btn__text')
    this.filtersDropdownEl = this.el.querySelector('.filter-btn__dropdown')
    this.filtersBtnEls = [...this.el.querySelectorAll('.filter-btn__dropdown__btn')]

    this.el.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('focusin', this.onFocusIn)
    document.addEventListener('click', this.onClickDoc)
  }

  toggleFilters() {
    if (this.isFiltersOpen)
      return this.closeFilters()

    this.openFilters()
  }

  openFilters() {
    this.isFiltersOpen = true

    this.filtersBtnEl.setAttribute('aria-expanded', 'true')
    this.filtersDropdownEl.classList.add('active')
  }

  closeFilters(focusAfter) {
    if (!this.isFiltersOpen)
      return

    this.isFiltersOpen = false
    this.filtersBtnEl.setAttribute('aria-expanded', 'false')
    this.filtersDropdownEl.classList.remove('active')

    focusAfter && focusAfter.focus()
  }

  onKeyDown(e) {
    if (e.key === 'Escape')
      this.closeFilters(this.filtersBtnEl)
  }

  onFocusIn(e) {
    if (!this.el.contains(e.target))
      this.closeFilters()
  }

  onClickDoc(e) {
    if (!this.el.contains(e.target))
      this.closeFilters()
  }

  filterByTag(e) {
    if (this.isFiltering)
      return

    if (e.target.classList.contains('active'))
      return this.closeFilters()

    this.isFiltering = true

    this.filtersBtnEls.forEach(btn => btn.classList.remove('active'))
    e.target.classList.add('active')
    this.filtersBtnTextEl.textContent = e.target.textContent

    this.filtersBtnEl.classList.toggle('is-filtered', e.target.dataset.tag !== 'all')

    this.closeFilters()

    this.call(
      'filter',
      e.target.dataset.tag,
      this.moduleToFilter
    )
  }

  onFinishedFiltering() {
    this.isFiltering = false
    ScrollTrigger.refresh()
  }

  destroy() {
    this.el.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('focusin', this.onFocusIn)
    document.removeEventListener('click', this.onClickDoc)
  }
}
